import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GravidadeTagComponent } from './gravidade-tag/gravidade-tag.component';
import { ResultadoExameTagComponent } from './resultado-exame-tag/resultado-exame-tag.component';
import { GenericTagComponent } from './generic-tag/generic-tag.component';
import { AppointmentStatusTagComponent } from './appointment-status-tag/appointment-status-tag.component';
import { AppointmentModalityTagComponent } from './appointment-modality-tag/appointment-modality-tag.component';
import { ButtonAllModule } from '@syncfusion/ej2-angular-buttons';
import { TooltipAllModule } from '@syncfusion/ej2-angular-popups';
import { AcompanhamentoTipoTagComponent } from './acompanhamento-tipo-tag/acompanhamento-tipo-tag.component';



@NgModule({
  declarations: [
    GravidadeTagComponent,
    ResultadoExameTagComponent,
    GenericTagComponent,
    AppointmentStatusTagComponent,
    AppointmentModalityTagComponent,
    AcompanhamentoTipoTagComponent
  ],
  imports: [
    CommonModule,
    ButtonAllModule,
    TooltipAllModule
  ],
  exports: [
    GravidadeTagComponent,
    ResultadoExameTagComponent,
    GenericTagComponent,
    AppointmentStatusTagComponent,
    AppointmentModalityTagComponent,
    AcompanhamentoTipoTagComponent
  ]
})
export class TagModule { }
